import { useEffect, useState } from "react";
import { buscarUsuarioByIdService } from "../../../services/buscarUsuarioByIdService";

export const useInteressados = (
  usuarioIds: number[] | null,
  datasContatos: string[] | null
) => {
  const [interessados, setInteressados] = useState<
    { nome: string; telefone: string; dataContato: string }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (!usuarioIds || usuarioIds.length === 0) return; // nada a buscar

    const buscar = async () => {
      setLoading(true);
      try {
        const results = await Promise.all(
          usuarioIds.map((id) => buscarUsuarioByIdService(id))
        );
        // results é um array de arrays? Se sim, usamos flat()
        const interessadosFormatados = results.flat().map((user, index) => ({
          nome: `${user.nome} ${user.sobrenome}`,
          telefone: user.celular ?? "",
          dataContato: datasContatos?.[index] ?? "", // pega a data correspondente
        }));

        setInteressados(interessadosFormatados);
      } catch (err) {
        console.error("Erro ao buscar interessados:", err);
      } finally {
        setLoading(false);
      }
    };

    buscar();
  }, [usuarioIds, datasContatos]);

  return { interessados, loading };
};
